module.exports = __webpack_public_path__ + "static/img/address.7d7c363e.svg";